import { render, staticRenderFns } from "./LiberarDadosModal.vue?vue&type=template&id=71511dd6&scoped=true"
import script from "./LiberarDadosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LiberarDadosModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LiberarDadosModal.vue?vue&type=style&index=0&id=71511dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71511dd6",
  null
  
)

export default component.exports